import React, { Component } from 'react';

import request from '../client/client';

class FormClient extends Component {

  state = {
    criarClienteError: null
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  criarCliente = async (e) => {
    e.preventDefault();

    try {
      const cliente = await request.post('/clients', {
        "email": this.state.email,
        "password": this.state.password, 
        "name": this.state.clientName
      })
      await localStorage.setItem('clientID', cliente.data.client._id);
      this.props.history.replace('/criar-store');

    } catch (err) {
      console.log(err);
      this.setState({
        /* Adicionar tratamento de erro mais específico */
        criarClienteError: "Não conseguimos cadastrar o cliente"
      })
    };
  }

  render() {
    return (
      <div className="text-center">
        <form onSubmit={this.criarCliente}>
          <input
            className="form-item"
            placeholder="Email"
            name="email"
            type="text"
            onChange={this.handleChange}
          />
          <input
            className="form-item"
            placeholder="Password"
            name="password"
            type="password"
            onChange={this.handleChange}
          
          />
          <input
            className="form-item"
            placeholder="Nome"
            name="clientName"
            type="text"
            onChange={this.handleChange}
          />
          {
            !!this.state.criarClienteError &&
            <div className="error-message">
              {this.state.criarClienteError}
            </div>
          }
          <input
            className="form-submit"
            value="Enviar"
            type="submit"
          />
        </form>
      </div>
    )
  }
}

export default FormClient;



// WEBPACK FOOTER //
// ./src/components/form-client/index.js